import { useMemo } from 'react';

import { getPossibleParents, HierarchicalItem } from 'src/lib/hierarchy';
import { Skill } from 'src/actions/skills/skillsResource';

export type SkillOption = {
  disabled: boolean;
  label: string;
  text: string;
  value: string;
};

export const useDropdownOptions = (
  skills: HierarchicalItem<Skill>[],
  skill?: HierarchicalItem<Skill>
): SkillOption[] => {
  return useMemo(() => {
    const possibleParents = skill ? getPossibleParents(skills, skill) : skills;

    return possibleParents.map(skill => {
      const fullName = nameWithAncestry(skill);

      return { disabled: skill.disabled, label: fullName, text: fullName, value: skill.id };
    });
  }, [skills, skill]);
};

export function nameWithAncestry(skill: HierarchicalItem<Skill>): string {
  // Fall back on skill name if skill hierarchy is not yet loaded.
  return skill.ancestralNames?.join(' > ') || skill.name;
}
